import { Box, Flex } from '@chakra-ui/react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import { Condition, Iteration } from 'Component/others';
import { TextRegular } from 'UiKit/typography';
import Badge from 'UiKit/badge';

import styles from './styles.module.css';

const PermissionsBadge = ({ permissions, accessPermission, id }) => {
  const navigate = useNavigate();

  const MAX_BADGES = 4;
  const visiblePermissions = permissions.slice(0, MAX_BADGES);
  const totalHiddenPermission = permissions.length - visiblePermissions.length;

  const onClickBadge = () => {
    if (accessPermission?.isCanEdit) navigate(`/master-data/access/upsert/${id}`);
  };

  return (
    <Flex className={styles['permission__container']}>
      <Condition statement={permissions?.length} fallback={<TextRegular className={styles['column__text']}>-</TextRegular>}>
        <Iteration
          items={visiblePermissions}
          render={(permission, index) => (
            <Badge key={`${permission}-${index}`} variant="outlined">
              <Box as="span" className={styles['permission__text']}>
                {permission}
              </Box>
            </Badge>
          )}
        />
      </Condition>

      <Condition statement={totalHiddenPermission > 0}>
        <TextRegular
          className={clsx(`${styles['permission__more']} 
          ${!accessPermission?.isCanEdit && styles['permission__more--disabled']}
          `)}
          onClick={onClickBadge}
        >
          and {totalHiddenPermission} more
        </TextRegular>
      </Condition>
    </Flex>
  );
};

export default PermissionsBadge;
